import React, { useState } from 'react';
import FileUploader from '../components/FileUploader';
import ProcessingIndicator from '../components/ProcessingIndicator';
import { convertToJPG } from '../utils/imageUtils';
import { saveAs } from 'file-saver';
import JSZip from 'jszip';
import './ToolPage.css';

const ImageToJPG = () => {
    const [files, setFiles] = useState([]);
    const [processing, setProcessing] = useState(false);
    const [processedFiles, setProcessedFiles] = useState([]);

    const handleFilesSelected = (selectedFiles) => {
        setFiles(selectedFiles);
        setProcessedFiles([]);
    };

    const handleConvert = async () => {
        if (files.length === 0) return;

        setProcessing(true);
        const converted = [];

        try {
            for (const file of files) {
                const jpgFile = await convertToJPG(file);
                converted.push(jpgFile);
            }
            setProcessedFiles(converted);
        } catch (error) {
            alert('Conversion failed: ' + error.message);
        } finally {
            setProcessing(false);
        }
    };

    const handleDownload = async () => {
        if (processedFiles.length === 1) {
            saveAs(processedFiles[0], processedFiles[0].name);
        } else {
            const zip = new JSZip();
            processedFiles.forEach((file) => {
                zip.file(file.name, file);
            });
            const content = await zip.generateAsync({ type: 'blob' });
            saveAs(content, 'converted_images.zip');
        }
    };

    return (
        <div className="tool-page">
            <div className="tool-header">
                <h1>🖼️ Convert to JPG</h1>
                <p>Convert various image formats to JPG format</p>
            </div>

            <div className="tool-content">
                <FileUploader
                    accept="image/*"
                    onFilesSelected={handleFilesSelected}
                    title="Upload Images"
                    description="Supports PNG, WebP, BMP and other formats"
                />

                {files.length > 0 && !processing && processedFiles.length === 0 && (
                    <div className="tool-controls">
                        <button className="btn btn-primary" onClick={handleConvert}>
                            Convert to JPG
                        </button>
                    </div>
                )}

                {processing && <ProcessingIndicator message="Converting images..." />}

                {processedFiles.length > 0 && (
                    <div className="results">
                        <h3>Conversion Complete!</h3>
                        <p>Successfully converted {processedFiles.length} image(s)</p>
                        <button className="btn btn-primary" onClick={handleDownload}>
                            {processedFiles.length === 1 ? 'Download' : 'Download All'}
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ImageToJPG;
